__turbopack_context__.v({
  "active": "BuildRadio-module-sass-module__LpIdLG__active",
  "buttons": "BuildRadio-module-sass-module__LpIdLG__buttons",
  "mutant": "BuildRadio-module-sass-module__LpIdLG__mutant",
  "radio-group": "BuildRadio-module-sass-module__LpIdLG__radio-group",
  "wrapper": "BuildRadio-module-sass-module__LpIdLG__wrapper",
});
